const NUMBER = 'number';
export default function(value) {
    const localValue = typeof value === NUMBER ? String(value) : value;

    if (localValue) {
        const cleanedAmount = localValue.replace(/[^0-9,.-]+/g, '');

        // Заменяем запятую на точку для корректного преобразования в число
        const amount = parseFloat(cleanedAmount.replace(',', '.'));

        // Возвращаем форматированную строку с валютным символом
        return amount.toLocaleString('uk-UA', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    } else return '';
}
